import { createFileRoute } from '@tanstack/react-router';
import ForgotPassword from '../components/ForgotPassword';

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: () => ({ documentTitle: { main: 'forgotPassword.passwordReset' } }),
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ForgotPasswordRoute,
});

function ForgotPasswordRoute() {
  return <ForgotPassword />;
}
